import React from "react";
import { LabeledIcon } from "../../../../Views/Studio/Components/StudioIcons";

export type TStudioCardTag = {
  ui: {
    title: string;
  };
  facet: {
    type: string[];
  };
};

export const StudioCards = ({ cards }: any) => {
  let unique: any = [];

  if (cards?.length) {
    unique = [
      ...new Map(cards.map((item: any) => [item.ui.title, item])).values(),
    ];
  }
  return (
    <>
      {unique.map((card: any, i: any) => {
        return (
          <LabeledIcon
            key={`tag-${card.ui.title}`}
            cursor="pointer"
            category={card?.facet?.type[0] ?? ""}
            text={card?.ui?.title}
            onQuery={() => {}}
            onClick={() => {
              const win = window.open(`/studio/${card._id}`, "_blank");
              if (win) win.focus();
            }}
            setCreatorCardModal={() => {}}
            queryType={"type"}
            isModal={false}
            mr={3}
            mb={3}
            maxHeight={"100px"}
            borderWidth={2}
          />
        );
      })}
    </>
  );
};
